<template>
  <div class="mockup-preview" :class="current.destroy ? 'mockup--destroy' : ''">
    <div class="mockup-preview__header">
      <div
        v-if="!current.destroy"
        class="mockup__btn-icon"
        :class="show ? 'mockup__btn-icon--active' : ''"
        @click="show = !show"
      >
        <icon-arrow-down v-if="show" />
        <icon-arrow-up v-else />
      </div>

      <div
        v-if="!current.destroy"
        class="mockup__btn-icon"
        :class="current.active ? 'mockup__btn-icon--active' : ''"
        @click="current.active = !current.active"
      >
        <icon-check v-if="current.active" />
      </div>

      <div
        class="mockup__btn-icon"
        :class="current.destroy ? 'mockup__btn-icon--active' : ''"
        @click="current.destroy = !current.destroy"
      >
        <icon-trash />
      </div>

      <slot name="order" v-if="!current.destroy"></slot>

      <h1 class="mockup-preview__header-title" @click="show = !show">
        {{ `${current.jsClass} - ${current.order + 1}ª` }}
        <span>{{ current.destroy ? " - DELETE" : "" }}</span>
      </h1>
    </div>

    <div v-show="show && !current.destroy" class="mockup-preview__infos">
      <mockup-preview-dynamic
        v-if="current.jsClass === 'MockupPreviewDynamicModel'"
        :current="current"
        :colors="colors"
        @setColors="(r) => $emit('setColors', r)"
        @addColor="(r) => $emit('addColor', r)"
      >
        <template slot="stores">
          <mockup-preview-stores :current="current" />
        </template>

        <template slot="zoom">
          <mockup-preview-zoom :current="current" />
        </template>
      </mockup-preview-dynamic>

      <mockup-preview-image
        v-else-if="current.jsClass === 'MockupPreviewImageModel'"
        :current="current"
      >
        <template slot="stores">
          <mockup-preview-stores :current="current" />
        </template>
      </mockup-preview-image>

      <mockup-preview-model-3d
        v-else-if="current.jsClass === 'MockupPreviewModel3d'"
        :current="current"
      >
        <template slot="stores">
          <mockup-preview-stores :current="current" />
        </template>
      </mockup-preview-model-3d>

      <mockup-preview-video
        v-else-if="current.jsClass === 'MockupPreviewVideoModel'"
        :current="current"
      >
        <template slot="stores">
          <mockup-preview-stores :current="current" />
        </template>
      </mockup-preview-video>

      <mockup-preview-youtube-video
        v-else-if="current.jsClass === 'MockupPreviewYoutubeVideoModel'"
        :current="current"
      >
        <template slot="stores">
          <mockup-preview-stores :current="current" />
        </template>
      </mockup-preview-youtube-video>
    </div>
  </div>
</template>

<script>
import MockupPreviewDynamic from "./mockup-preview-dynamic/MockupPreviewDynamic.vue";
import MockupPreviewImage from "./mockup-preview-image/MockupPreviewImage.vue";
import MockupPreviewModel3d from "./mockup-preview-model-3d/MockupPreviewModel3d.vue";
import MockupPreviewVideo from "./mockup-preview-video/MockupPreviewVideo.vue";
import MockupPreviewYoutubeVideo from "./mockup-preview-youtube-video/MockupPreviewYoutubeVideo.vue";

import MockupPreviewZoom from "./mockup-preview-zoom/MockupPreviewZoom.vue";
import MockupPreviewStores from "./mockup-preview-stores/MockupPreviewStores.vue";

import IconTrash from "@gocasebr/go-shared/dist/trash/Trash";
import IconCheck from "@gocasebr/go-shared/dist/check/Check";
import IconArrowUp from "@gocasebr/go-shared/dist/arrow-up/ArrowUp";
import IconArrowDown from "@gocasebr/go-shared/dist/arrow-down/ArrowDown";

export default {
  components: {
    MockupPreviewDynamic,
    MockupPreviewImage,
    MockupPreviewVideo,
    MockupPreviewYoutubeVideo,
    MockupPreviewZoom,
    MockupPreviewStores,
    IconTrash,
    IconCheck,
    IconArrowUp,
    IconArrowDown,
    MockupPreviewModel3d,
  },
  props: {
    current: Object,
    colors: Array,
    length: Number,
  },
  data() {
    return {
      show: true,
    };
  },
  watch: {
    length() {
      this.show = this.length - 1 === this.current.order;
    },
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview {
  margin: 6px;
  border: 1px solid #f2f2f4;
  border-radius: 5px;

  .mockup-preview__header {
    padding: 6px;
    width: 100%;
    display: grid;
    grid-template-columns: auto auto auto auto 1fr;
    align-items: center;
    gap: 6px;
    background: #f2f2f4;

    &-title {
      margin: 0;
      font-size: 16px;
      color: #888;
      flex: 1;
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }
  }
}
</style>
